import { originatesFromRemoteBackendAgent, type Transaction } from '@canvas/transaction';

const MIN_PROGRESSIVE_REVEAL_ENTRY_COUNT = 2;

interface GetBackendAgentAddedEntryIdsOptions {
  currentEntryIds: readonly string[];
  previousEntryIds: readonly string[];
  transaction: Transaction;
}

export function getBackendAgentAddedEntryIds({
  currentEntryIds,
  previousEntryIds,
  transaction
}: GetBackendAgentAddedEntryIdsOptions): readonly string[] {
  if (!originatesFromRemoteBackendAgent(transaction)) {
    return [];
  }

  const previousEntryIdSet = new Set(previousEntryIds);
  const addedEntryIds = currentEntryIds.filter(
    (entryId) => !previousEntryIdSet.has(entryId)
  );

  return addedEntryIds.length >= MIN_PROGRESSIVE_REVEAL_ENTRY_COUNT ? addedEntryIds : [];
}

export function getVisibleBackendAgentAddedEntryIds(
  addedEntryIds: readonly string[],
  visibleEntryIds: readonly string[]
): readonly string[] {
  const addedEntryIdSet = new Set(addedEntryIds);
  const visibleAddedEntryIds = visibleEntryIds.filter((entryId) =>
    addedEntryIdSet.has(entryId)
  );

  return visibleAddedEntryIds.length >= MIN_PROGRESSIVE_REVEAL_ENTRY_COUNT
    ? visibleAddedEntryIds
    : [];
}
